import { supabase } from "../../../supabaseClient" // ajuste o caminho se necessário

const BUCKET = "temp-logos"

export function generateSessionId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

// QR URL: mesma página /share + mobile=1 & qr={sessionId}
export function mobileUploadUrl(sessionId: string): string {
  const url = new URL(window.location.href)
  url.searchParams.set("mobile", "1")
  url.searchParams.set("qr", sessionId)
  return url.toString()
}

// Poll: verifica se o mobile já enviou uma imagem para essa sessão.
// Cada envio do celular tem um nome de arquivo único (ver uploadFile em
// upload-logo-mobile.tsx), então listamos tudo, ordenamos e pegamos o mais
// recente — o "name" devolvido é o que o caller usa pra saber se já viu
// essa foto antes ou se é uma nova.
export async function pollSessionLogo(sessionId: string): Promise<{ url: string; name: string } | null> {
  try {
    const { data, error } = await supabase.storage
      .from(BUCKET)
      .list(`${sessionId}/`, { sortBy: { column: "name", order: "desc" } })

    if (error || !data?.length) return null

    const file = data[0] // nomes começam com "logo-<timestamp>-...", então ordenar por nome já dá o mais recente

    const { data: urlData } = supabase.storage
      .from(BUCKET)
      .getPublicUrl(`${sessionId}/${file.name}`)

    return {
      url: urlData.publicUrl + `?t=${Date.now()}`,
      name: file.name,
    }
  } catch {
    return null
  }
}

// Delete após uso
export async function deleteSessionLogo(sessionId: string, fileName: string): Promise<void> {
  await supabase.storage
    .from(BUCKET)
    .remove([`${sessionId}/${fileName}`])
}